import React from 'react';
import PropTypes from 'prop-types';
import tickSVG from '../../../../../assets/icons/tick.svg';
import { SUPPORT } from '../../../../routes/paths';

const FAQ = ({ question, answer, history }) => (
  <div className="faq">
    <img src={tickSVG} />
    <div className="faq-text">
      <div className="faq-question">
        {question}
      </div>
      <div className="faq-answer">
        {answer}
      </div>
      <div className="faq-read-more" onClick={() => history.push(SUPPORT)}>
        Read more
      </div>
    </div>
  </div>
);

FAQ.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default FAQ;
